import React, { useContext } from 'react'
import { Card, CardBody } from 'react-bootstrap'
import { GetUserContext } from '../../Context/GetUserContext'
import ModalDownNF from '../ModalDownNF';
import { formatPrice } from '../../controller/views/formats';
import './AccountsPayable.css';

const CashPayment = () => {
    const { financeiro, setFinanceiro, axiosConfig, setFetchTimestamp, fetchTimestamp } = useContext(GetUserContext);
    console.log(financeiro?.Registro_Financeiros)

    return (
        <Card className='h-100'>
            <CardBody>
                <table className="table table-hover ">
                    <thead className='header-table'>
                        <tr>
                            <th scope="col">Data</th>
                            <th scope="col">N° Pedido</th>
                            <th scope="col">Empresa</th>
                            <th scope="col">Pagamento</th>
                            <th scope="col">Valor Total</th>
                            <th style={{ textAlign: "center" }} scope="col">NF/Boleto</th>
                        </tr>
                    </thead>

                    <tbody style={{ cursor: "pointer" }}>

                        {
                            financeiro?.Registro_Financeiros?.map((item, index) => (
                                item?.Contas_Pagars?.length === 0 &&
                                <tr key={index}>
                                    <td>{item?.Pedido?.Pedido_Feito}</td>
                                    <td>{item?.Pedido?.ID_Pedido}</td>
                                    <td>{financeiro?.company?.Corporate_Name}</td>
                                    <td>{item?.Forma_de_Pagamento?.Pagamento}</td>
                                    <td>R$ {formatPrice(item?.Valor_Total)}</td>

                                    {
                                        item?.Pedido?.Cancelado_adm != null ?
                                            (<td className='fileNF bg-danger-edit'>Cancelado</td>)
                                            :
                                            (<td className='fileNF'><ModalDownNF id={item?.ID_Pedido} /></td>)
                                    }
                                </tr>
                            ))
                        }
                    </tbody>
                </table>

            </CardBody>
        </Card>

    )
}

export default CashPayment